import { isDiscoverGamesGridCellEmpty } from "./formatters";

/** Mirrors {@see Eyeball\Enum\Game\GameStatus} case values. */
export enum DiscoverGameStatus {
	READY_FOR_CREATION = "ready_for_creation",
	GAME_CREATED_WITH_ISSUES = "game_created_with_issues",
	DONE = "done",
	WAITING_FOR_VIDEO = "waiting_for_video",
	WAITING_FOR_TEAMSHEET = "waiting_for_teamsheet",
	NEW = "new",
	CANCELLED = "cancelled",
	INFORMATION_PROVIDED = "information_provided",
	CREATED_BY_COACH = "created_by_coach",
	CREATED_BY_API = "created_by_api",
}

/**
 * Background colors for {@see Eyeball\Enum\Game\GameStatus} values (`GameMetadata.gameStatus`),
 * aligned with admin Discover Games game status column grading.
 */
export const DISCOVER_GAMES_GAME_STATUS_GRADE_COLORS: Record<string, string> = {
	[DiscoverGameStatus.READY_FOR_CREATION]: "#C0BE35",
	[DiscoverGameStatus.GAME_CREATED_WITH_ISSUES]: "#4607E5",
	[DiscoverGameStatus.DONE]: "#06A983",
	[DiscoverGameStatus.WAITING_FOR_VIDEO]: "#4E08FF",
	[DiscoverGameStatus.WAITING_FOR_TEAMSHEET]: "#4E08FF",
	[DiscoverGameStatus.NEW]: "#03C5FF",
	[DiscoverGameStatus.CANCELLED]: "#08D3A4",
	[DiscoverGameStatus.INFORMATION_PROVIDED]: "#C0BE35",
	[DiscoverGameStatus.CREATED_BY_COACH]: "#06A983",
	[DiscoverGameStatus.CREATED_BY_API]: "#06A983",
};

export function gameStatusGradeColor(statusRaw: unknown): string | undefined {
	if (isDiscoverGamesGridCellEmpty(statusRaw)) {
		return undefined;
	}
	const key = String(statusRaw).trim();
	return DISCOVER_GAMES_GAME_STATUS_GRADE_COLORS[key];
}
